<template>
  <div class="stepper" v-if="$breakpoint.isMobile && showStepper && stepsInformation.length">
    <span>
      {{$t('step')}}
      <span class="stepper__number">{{ currentStepInformation?.stepNumber }}</span>
      {{ $t('of') }}
      <span class="stepper__number">{{ totalSteps }}</span>
    </span>
    <i class="fas fa-caret-right mx-2"></i>
    <span class="stepper__name">{{ $t(currentStepInformation?.label) }}</span>
  </div>
</template>
<script>
  export default {
    name: 'stepper',
    computed: {
      stepsInformation: function () {
        return this.$store.getters.getStepsInformation
      },
      totalSteps: function () {
        return this.$store.getters.getTotalSteps
      },
      currentStepInformation: function () {
        return this.$store.getters.getCurrentStepInformation
      },
      previousStep: function () {
        return this.$store.getters.getPreviousStep
      },
      showStepper: function () {
        return this.$store.getters.getShowStepper
      },
    },
    mounted: function () {
      this.displayStepperDispatch(this.$route)
    },
    watch: {
      '$route': {
        deep: true,
        handler (toRoute) {
          this.displayStepperDispatch(toRoute)
        }
      }
    },
    methods: {
      displayStepperDispatch: function (routeToCheck) {
        try {
          this.$nextTick(() => {
            const stepsInformation = this.$store.getters.getStepsInformation || []
            const routeNameIsPartOfSteps = stepsInformation.some(
              stepInfo => routeToCheck.name === stepInfo.route
            )
            // TODO: Hacer que chequee el flujo para que pase la condicion. En el caso que se vaya a purchase por ej,
            // Por medio de pagar un extra service
            // const conditionToPass = this.currentStepInformation?.stepNumber === 1 || stepsInformation.some(
            //   stepInfo => this.previousStep.route === stepInfo.route
            // )
            if (routeNameIsPartOfSteps) {
              this.$store.dispatch('showStepper')
            } else {
              this.$store.dispatch('hideStepper')
            }
          })
        } catch (error) {
          console.error('stepperError', error)
          this.$store.dispatch('hideStepper')
        }
      },
    }

  }
</script>
<style lang="sass">
.stepper
  width: 100%
  padding: 16px 12px
  border-top: 1px solid var(--color-overlay-20, rgba(33, 33, 33, 0.20))
  border-bottom: 1px solid var(--color-overlay-20, rgba(33, 33, 33, 0.20))
  background: var(--color-on-secondary, #FFF)
  font-size: 16px
  color: var(--color-on-surface, #34373A)
  &__number,
  &__name
    font-weight: 700
main
  flex-direction: column
</style>
